import apiClient from './axios';
import type { PermissionRecord } from '@cms/models';

export const permissionApi = {
  getAll: async (): Promise<PermissionRecord[]> => {
    const response = await apiClient.get<PermissionRecord[]>('/permissions');
    return response.data;
  },
};
